import { Breakpoint } from '@mui/material';

export const spacing: Partial<Record<Breakpoint, number>> = { xs: 1 };

export const PageContentPadding: Partial<Record<Breakpoint, number>> = { ...spacing, sm: 2 };
